import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Select } from '@ngxs/store';
import { AuthState } from 'app/core/auth/core/auth.state';
import { LogService } from 'app/core/logger';
import { RoutingService } from 'app/core/navigation';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, mergeMap, tap, timeout } from 'rxjs/operators';
import { ApplicationStateService } from './application-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard  {
  @Select(AuthState.signedIn) signedIn$: Observable<boolean>;
  isMaintenance$: Observable<boolean>; 

  constructor(
    private routingService: RoutingService,
    private logger: LogService,
    private applicationStateService: ApplicationStateService) { 

      this.isMaintenance$ = this.applicationStateService.getMaintenanceState();
    }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.signedIn$.pipe(
      tap((isAuthorized) => this.logger.debug('AuthorizationGuard canActivate isAuthorized...:', isAuthorized)),
      filter((isAuthorized) => isAuthorized != null),
      mergeMap(isAuthorized => this.isMaintenance$.pipe(
        tap(maintenance => { if (maintenance) { this.routingService.navigateToMaintenance(state.url); } }),
        map(_ => isAuthorized),
      )),
      timeout(10000),
      catchError((err, caught) => {
        return of(false);
      }),
      map((isAuthorized: boolean) => {
        this.logger.debug('AuthorizationGuard, afterFilter isAuthorized: ' + isAuthorized);

        if (isAuthorized) {
          const hasPermissions = true; // this.appUserService.userHasPermissions(route.data.auth);
          if (hasPermissions) {
            return true;
          } else {
            this.routingService.navigateToForbidden(state.url);
          }
        }

        if (!isAuthorized) {
          this.routingService.navigateToUnauthorized(state.url);
        }

        return false;
      }),
    );
  }
}
